import React from 'react';
import { Card, Descriptions } from 'antd';
import PropTypes from 'prop-types';
import DateDisplay from '../../../layout/DateDisplay';
import { FileList } from 'components/layout';

const ConfirmExtensionDetail = ({ data, loading }) => {
  const extension = loading ? {} : data.extensions[0];
  const profile = loading ? {} : extension.project.profile;

  return (
    <Card loading={loading} title="Confirm Extension Detail">
      {!loading && (
        <Descriptions>
          <Descriptions.Item label="New Completion Date" span={3}>
            <DateDisplay date={extension.newCompletionDate} />
          </Descriptions.Item>
          <Descriptions.Item label="Original Completion Date" span={1}>
            <DateDisplay date={profile.originalCompletionDate} />
          </Descriptions.Item>
          <Descriptions.Item label="Last Approved Completion" span={1}>
            <DateDisplay date={profile.lastApprovedCompletionDate} />
          </Descriptions.Item>
          <Descriptions.Item label="Deadline of Using Up Funding" span={1}>
            <DateDisplay date={profile.deadlineOfUsingUpFunding} />
          </Descriptions.Item>
          <Descriptions.Item label="Progress Report" span={3}>
            <FileList files={[extension?.progressReport]} />
          </Descriptions.Item>
          <Descriptions.Item label="Supplements" span={3}>
            <FileList files={extension?.supplements} />
          </Descriptions.Item>
          <Descriptions.Item label="Justification" span={3}>
            {extension.justification}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Card>
  );
};

ConfirmExtensionDetail.defaultProps = {
  data: {},
  loading: true,
};

ConfirmExtensionDetail.propTypes = {
  data: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default ConfirmExtensionDetail;
